import { Sprite, SpriteMaterial, Texture } from 'three';

import { RenderOrder } from '@paragon/three-shared';

const errorMaterial = new SpriteMaterial({});

interface SvgVisualProps {
  iconName: string;
  rotation: number;
  size: number;
}

export class SvgVisual extends Sprite {
  constructor(props: SvgVisualProps) {
    super();
    this.material = SvgVisual.buildMaterial(props);
    this.renderOrder = RenderOrder.SvgVisual;
    this.scale.set(props.size, props.size, 1);
  }

  private static buildMaterial(svgVisualData: SvgVisualProps) {
    const { iconName, rotation } = svgVisualData;

    const canvas = document.createElement('canvas');
    const size = 512;
    canvas.width = size;
    canvas.height = size;
    const context = canvas.getContext('2d');
    if (!context) {
      console.warn('Canvas context was null!');
      return errorMaterial;
    }
    context.fillStyle = '#ffffff';
    context.strokeStyle = '#000000';
    const svgElement = document.getElementById(iconName);
    if (!svgElement) {
      console.warn('Svg Element could not be found');
      return errorMaterial;
    }
    const svgPaths = Array.from(svgElement.children).filter((item) => item.localName === 'path');
    if (svgPaths.length === 0) {
      console.warn('Path on svg could not be found');
      return errorMaterial;
    }

    if (!svgPaths.every((svgPath) => svgPath.getAttribute('d'))) {
      console.warn('Could not find path values on d attribute');
      return errorMaterial;
    }
    const viewbox = svgElement.getAttribute('viewBox');
    if (!viewbox) {
      console.warn('Could not find view box on svg!');
      return errorMaterial;
    }
    // scale by svg view box to fit canvas properly
    const scaleFactorX = size / parseFloat(viewbox.split(' ')[2]);
    const scaleFactorY = size / parseFloat(viewbox.split(' ')[3]);
    context.scale(scaleFactorX, scaleFactorY);
    context.scale(1, 1);
    for (const svgPath of svgPaths) {
      const pathValues = svgPath.getAttribute('d');
      context.globalAlpha = svgPath.getAttribute('fill') === 'none' ? 0 : 1;
      const strokeWidthAttribute = svgPath.getAttribute('stroke-width');
      context.lineWidth = strokeWidthAttribute ? parseFloat(strokeWidthAttribute) : 24;
      if (!pathValues) {
        console.warn(`Missing path values for path on ${iconName}`);
        continue;
      }
      const path = new Path2D(pathValues);
      context.stroke(path);
      context.fill(path);
    }

    const texture = new Texture(canvas);
    texture.needsUpdate = true;
    texture.anisotropy = 2;
    return new SpriteMaterial({
      depthTest: false,
      depthWrite: false,
      map: texture,
      rotation,
    });
  }

  public setRotationValue(rotation: number) {
    const spriteMaterial = this.material;
    spriteMaterial.rotation = rotation;
  }

  public dispose() {
    const spriteMaterial = this.material;
    if (spriteMaterial.map) spriteMaterial.map.dispose();
    this.material.dispose();
  }
}
